'use strict';

var cov_1h2rdnnjaa = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/components/statisticDetails/statisticDetails.js',
        hash = '4407041011acadf018f1079fef2fe8776e052660',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/components/statisticDetails/statisticDetails.js',
        statementMap: {
            '0': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 12,
                    column: 11
                }
            },
            '1': {
                start: {
                    line: 17,
                    column: 0
                },
                end: {
                    line: 25,
                    column: 3
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 2,
                        column: 4
                    },
                    end: {
                        line: 2,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 2,
                        column: 19
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                line: 2
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 5,
                        column: 4
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 5,
                        column: 15
                    },
                    end: {
                        line: 6,
                        column: 5
                    }
                },
                line: 5
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 8,
                        column: 4
                    },
                    end: {
                        line: 8,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 8,
                        column: 12
                    },
                    end: {
                        line: 13,
                        column: 5
                    }
                },
                line: 8
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatisticDetailsController = function () {
    function StatisticDetailsController() {
        _classCallCheck(this, StatisticDetailsController);

        cov_1h2rdnnjaa.f[0]++;
    }

    _createClass(StatisticDetailsController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_1h2rdnnjaa.f[1]++;
        }
    }, {
        key: 'filter',
        value: function filter() {
            cov_1h2rdnnjaa.f[2]++;
            cov_1h2rdnnjaa.s[0]++;

            this.statistics.$refresh({
                'start_date__gt': this.startDate,
                'end_date__lt': this.endDate
            });
        }
    }]);

    return StatisticDetailsController;
}();

cov_1h2rdnnjaa.s[1]++;


angular.module('app').component('statisticDetails', {
    templateUrl: 'app/components/statisticDetails/statisticDetails.html',
    controller: StatisticDetailsController,
    bindings: {
        statistics: '<'
    }
});